let fieldConfig = [
    // 事业部
    {
        version: 4.1,
        profileType: '146',
        queryForm: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
        ],
        table: [
            {
                label: '事业部',
                selected: true,
                default: false,
                sort: false,
                rNum: 2,
                fatherId: 5,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     sort: false,
            //     rNum: 2,
            //     fatherId: 6,
            // },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 1,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 2,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 3,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 4,
            },
        ],
        tableItem: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                childId: 5,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     name: 'taxNum',
            //     sort: false,
            //     childId: 6,
            // },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'personTaxNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personSuccessNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personFailureNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personNotOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'vatTaxNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatSuccessNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatFailureNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatNotOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'enterpriseTaxNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseSuccessNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseFailureNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseNotOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'stampTaxNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampOnlineNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampSuccessNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampFailureNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampNotOnlineNum',
                sort: false,
                childId: 4,
            },
        ],
        colspanList: [
            { label: '税号总数', selected: true, childId: 1 },
            { label: '已上线', selected: true, childId: 1 },
            { label: '成功', selected: true, childId: 1 },
            { label: '失败', selected: true, childId: 1 },
            { label: '未上线', selected: true, childId: 1 },
            { label: '税号总数', selected: true, childId: 2 },
            { label: '已上线', selected: true, childId: 2 },
            { label: '成功', selected: true, childId: 2 },
            { label: '失败', selected: true, childId: 2 },
            { label: '未上线', selected: true, childId: 2 },
            { label: '税号总数', selected: true, childId: 3 },
            { label: '已上线', selected: true, childId: 3 },
            { label: '成功', selected: true, childId: 3 },
            { label: '失败', selected: true, childId: 3 },
            { label: '未上线', selected: true, childId: 3 },
            { label: '税号总数', selected: true, childId: 4 },
            { label: '已上线', selected: true, childId: 4 },
            { label: '成功', selected: true, childId: 4 },
            { label: '失败', selected: true, childId: 4 },
            { label: '未上线', selected: true, childId: 4 },
        ],
    },
    // 所属区域
    {
        version: 4.1,
        profileType: '147',
        queryForm: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
        ],
        table: [
            {
                label: '事业部',
                selected: true,
                default: false,
                sort: false,
                rNum: 2,
                fatherId: 5,
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                sort: false,
                rNum: 2,
                fatherId: 6,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     sort: false,
            //     rNum: 2,
            //     fatherId: 7,
            // },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 1,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 2,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 3,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                sort: false,
                cNum: 5,
                fatherId: 4,
            },
        ],
        tableItem: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                childId: 5,
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
                sort: false,
                childId: 6,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     name: 'taxNum',
            //     sort: false,
            //     childId: 7,
            // },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'personTaxNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personSuccessNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personFailureNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personNotOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'vatTaxNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatSuccessNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatFailureNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatNotOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'enterpriseTaxNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseSuccessNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseFailureNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseNotOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'stampTaxNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampOnlineNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampSuccessNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampFailureNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampNotOnlineNum',
                sort: false,
                childId: 4,
            },
        ],
        colspanList: [
            { label: '税号总数', selected: true, childId: 1 },
            { label: '已上线', selected: true, childId: 1 },
            { label: '成功', selected: true, childId: 1 },
            { label: '失败', selected: true, childId: 1 },
            { label: '未上线', selected: true, childId: 1 },
            { label: '税号总数', selected: true, childId: 2 },
            { label: '已上线', selected: true, childId: 2 },
            { label: '成功', selected: true, childId: 2 },
            { label: '失败', selected: true, childId: 2 },
            { label: '未上线', selected: true, childId: 2 },
            { label: '税号总数', selected: true, childId: 3 },
            { label: '已上线', selected: true, childId: 3 },
            { label: '成功', selected: true, childId: 3 },
            { label: '失败', selected: true, childId: 3 },
            { label: '未上线', selected: true, childId: 3 },
            { label: '税号总数', selected: true, childId: 4 },
            { label: '已上线', selected: true, childId: 4 },
            { label: '成功', selected: true, childId: 4 },
            { label: '失败', selected: true, childId: 4 },
            { label: '未上线', selected: true, childId: 4 },
        ],
    },
    // 管理城市
    {
        version: 4.1,
        profileType: '148',
        queryForm: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                type: 'managerCityNo',
            },
        ],
        table: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                rNum: 2,
                fatherId: 5,
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'specialDict',
                specialDict: 'belleRegionList',
                sort: false,
                rNum: 2,
                fatherId: 6,
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                sort: false,
                rNum: 2,
                fatherId: 7,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     name: 'regionNo',
            //     sort: false,
            //     rNum: 2,
            //     fatherId: 8,
            // },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 1,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 2,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 3,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 4,
            },
        ],
        tableItem: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                childId: 5,
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
                sort: false,
                childId: 6,
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                sort: false,
                rNum: 2,
                childId: 7,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     name: 'taxNum',
            //     sort: false,
            //     childId: 8,
            // },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'personTaxNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personSuccessNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personFailureNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personNotOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'vatTaxNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatSuccessNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatFailureNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatNotOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'enterpriseTaxNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseSuccessNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseFailureNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseNotOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'stampTaxNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampOnlineNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampSuccessNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampFailureNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampNotOnlineNum',
                sort: false,
                childId: 4,
            },
        ],
        colspanList: [
            { label: '税号总数', selected: true, childId: 1 },
            { label: '已上线', selected: true, childId: 1 },
            { label: '成功', selected: true, childId: 1 },
            { label: '失败', selected: true, childId: 1 },
            { label: '未上线', selected: true, childId: 1 },
            { label: '税号总数', selected: true, childId: 2 },
            { label: '已上线', selected: true, childId: 2 },
            { label: '成功', selected: true, childId: 2 },
            { label: '失败', selected: true, childId: 2 },
            { label: '未上线', selected: true, childId: 2 },
            { label: '税号总数', selected: true, childId: 3 },
            { label: '已上线', selected: true, childId: 3 },
            { label: '成功', selected: true, childId: 3 },
            { label: '失败', selected: true, childId: 3 },
            { label: '未上线', selected: true, childId: 3 },
            { label: '税号总数', selected: true, childId: 4 },
            { label: '已上线', selected: true, childId: 4 },
            { label: '成功', selected: true, childId: 4 },
            { label: '失败', selected: true, childId: 4 },
            { label: '未上线', selected: true, childId: 4 },
        ],
    },
    //主管税局
    {
        version: 4.1,
        profileType: '149',
        queryForm: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                type: 'managerCityNo',
            },
            {
                label: '主管税局省(市)',
                selected: true,
                default: false,
                name: 'province',
                type: 'taxBureauId',
            },
        ],
        table: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                rNum: 2,
                fatherId: 5,
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'specialDict',
                specialDict: 'belleRegionList',
                sort: false,
                rNum: 2,
                fatherId: 6,
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                sort: false,
                rNum: 2,
                fatherId: 7,
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
                sort: false,
                rNum: 2,
                fatherId: 8,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     name: 'regionNo',
            //     sort: false,
            //     rNum: 2,
            //     fatherId: 9,
            // },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 1,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 2,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 3,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 5,
                fatherId: 4,
            },
        ],
        tableItem: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                childId: 5,
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
                sort: false,
                childId: 6,
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                sort: false,
                childId: 7,
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
                sort: false,
                childId: 8,
            },
            // {
            //     label: '税号总数',
            //     selected: true,
            //     default: false,
            //     name: 'taxNum',
            //     sort: false,
            //     childId: 9,
            // },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'personTaxNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personSuccessNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personFailureNum',
                sort: false,
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personNotOnlineNum',
                sort: false,
                childId: 1,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'vatTaxNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatSuccessNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatFailureNum',
                sort: false,
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatNotOnlineNum',
                sort: false,
                childId: 2,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'enterpriseTaxNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseSuccessNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseFailureNum',
                sort: false,
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseNotOnlineNum',
                sort: false,
                childId: 3,
            },
            {
                label: '税号总数',
                selected: true,
                default: false,
                name: 'stampTaxNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampOnlineNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampSuccessNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampFailureNum',
                sort: false,
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampNotOnlineNum',
                sort: false,
                childId: 4,
            },
        ],
        colspanList: [
            { label: '税号总数', selected: true, childId: 1 },
            { label: '已上线', selected: true, childId: 1 },
            { label: '成功', selected: true, childId: 1 },
            { label: '失败', selected: true, childId: 1 },
            { label: '未上线', selected: true, childId: 1 },
            { label: '税号总数', selected: true, childId: 2 },
            { label: '已上线', selected: true, childId: 2 },
            { label: '成功', selected: true, childId: 2 },
            { label: '失败', selected: true, childId: 2 },
            { label: '未上线', selected: true, childId: 2 },
            { label: '税号总数', selected: true, childId: 3 },
            { label: '已上线', selected: true, childId: 3 },
            { label: '成功', selected: true, childId: 3 },
            { label: '失败', selected: true, childId: 3 },
            { label: '未上线', selected: true, childId: 3 },
            { label: '税号总数', selected: true, childId: 4 },
            { label: '已上线', selected: true, childId: 4 },
            { label: '成功', selected: true, childId: 4 },
            { label: '失败', selected: true, childId: 4 },
            { label: '未上线', selected: true, childId: 4 },
        ],
    },
    // 机构税号
    {
        version: 4.1,
        profileType: '150',
        queryForm: [
            {
                label: '纳税人识别号',
                selected: true,
                default: true,
                name: 'saleCreditCode',
            },
            {
                label: '纳税人名称',
                selected: true,
                default: true,
                name: 'saleName',
            },
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'departmentNo',
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'regionNo',
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                type: 'managerCityNo',
            },
            {
                label: '主管税局省(市)',
                selected: true,
                default: false,
                name: 'province',
                type: 'taxBureauId',
            },
        ],
        table: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                rNum: 2,
                fatherId: 5,
            },
            {
                label: '所属区域',
                selected: true,
                default: false,
                name: 'regionName',
                type: 'specialDict',
                specialDict: 'belleRegionList',
                sort: false,
                rNum: 2,
                fatherId: 6,
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'managerCityName',
                sort: false,
                rNum: 2,
                fatherId: 7,
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
                sort: false,
                rNum: 2,
                fatherId: 8,
            },
            {
                label: '纳税人识别号',
                selected: true,
                default: false,
                name: 'saleCreditCode',
                sort: false,
                rNum: 2,
                fatherId: 9,
            },
            {
                label: '纳税人名称',
                selected: true,
                default: false,
                name: 'saleName',
                sort: false,
                rNum: 2,
                fatherId: 10,
            },
            {
                label: '纳税人类型',
                selected: true,
                default: false,
                name: 'taxplayerType',
                dict: 'taxplayer_type',
                type: 'dict',
                sort: false,
                rNum: 2,
                fatherId: 11,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 2,
                fatherId: 1,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 2,
                fatherId: 2,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 2,
                fatherId: 3,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'regionNo',
                sort: false,
                cNum: 2,
                fatherId: 4,
            },
        ],
        tableItem: [
            {
                label: '事业部',
                selected: true,
                default: false,
                name: 'departmentNo',
                dict: 'department_no',
                type: 'dict',
                sort: false,
                childId: 5,
            },
            {
                label: '所属区域',
                selected: false,
                default: false,
                name: 'regionName',
                type: 'regionNo',
                sort: false,
                childId: 6,
            },
            {
                label: '管理城市',
                selected: true,
                default: false,
                name: 'cityName',
                sort: false,
                childId: 7,
            },
            {
                label: '主管税局所在省（市）',
                selected: true,
                default: false,
                name: 'province',
                sort: false,
                childId: 8,
            },
            {
                label: '纳税人识别号',
                selected: true,
                default: false,
                name: 'saleCreditCode',
                sort: false,
                rNum: 2,
                childId: 9,
            },
            {
                label: '纳税人名称',
                selected: true,
                default: false,
                name: 'saleName',
                sort: false,
                rNum: 2,
                childId: 10,
            },
            {
                label: '纳税人类型',
                selected: true,
                default: false,
                name: 'taxplayerType',
                dict: 'taxplayer_type',
                type: 'dict',
                sort: false,
                rNum: 2,
                childId: 11,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personOnlineNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 1,
            },
            {
                label: '个人所得税',
                selected: true,
                default: false,
                name: 'personSuccessNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 1,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatOnlineNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 2,
            },
            {
                label: '增值税',
                selected: true,
                default: false,
                name: 'vatSuccessNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 2,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseOnlineNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 3,
            },
            {
                label: '企业所得税',
                selected: true,
                default: false,
                name: 'enterpriseSuccessNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 3,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampOnlineNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 4,
            },
            {
                label: '印花税',
                selected: true,
                default: false,
                name: 'stampSuccessNum',
                sort: false,
                type: 'isOnlineSucc',
                childId: 4,
            },
        ],
        colspanList: [
            { label: '是否上线', selected: true, childId: 1 },
            { label: '是否成功', selected: true, childId: 1 },
            { label: '是否上线', selected: true, childId: 2 },
            { label: '是否成功', selected: true, childId: 2 },
            { label: '是否上线', selected: true, childId: 3 },
            { label: '是否成功', selected: true, childId: 3 },
            { label: '是否上线', selected: true, childId: 4 },
            { label: '是否成功', selected: true, childId: 4 },
        ],
    },
]

export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/statisticsReport/fieldConfig.js